module.exports = __webpack_public_path__ + "img/start-ups-gray.db472e20.svg";